import { SupportedLanguage, Translations } from "../types/i18n";

export const translations: Record<SupportedLanguage, Translations> = {
    en: {
        homepage: {
            title: "You May be Entitled to Maximum Accident Compensation",
            text: "FREE No Obligation Consultation Pay Nothing!",
            text2: "Our Expert Lawyers Have Been Rated 5-stars",
            tcpa1: `By clicking on the "Next" button above, you consent, acknowledge, and agree to the following: Our`,
            tcpa2: " Terms of Service",
            tcpa3: `and Privacy Policy. That you are providing express "written" consent for caraccidentcounsel.com or its`,
            tcpa4: "network of lawyers and advocates to",
            tcpa5: "call you (autodialing, text and pre-recorded messaging for convenience) via telephone, mobile device(including SMS and MMS - charges may apply depending on your carrier, not by us, messaging frequency varies; text HELP for help; text STOP to cancel), even if your telephone number is currently listed on any internal, corporate, state or federal Do- Not - Call list.We take your privacy seriously and you may receive electronic communications, including periodic emails with important news, financial tips, tools and more.You can always unsubscribe at any time.All website interactions and phone calls are recorded for compliance and quality assurance purposes.Consent is not required as a condition to utilize caraccidentcounsel.com services and you are under no obligation to purchase anything.",
            tcpa6: "This site is not a part of the Facebook website or Facebook Inc. Additionally, This site is NOT endorsed by Facebook in any way. FACEBOOK is a trademark of FACEBOOK, Inc.",
            tcpa7: "This site is not a part of the YouTube website or Google, LLC. Additionally, This site is NOT endorsed by Google in any way.YouTube is a trademark of Google, LLC.",
            tcpa8: "PAID ATTORNEY ADVERTISEMENT: This Website is a group advertisement. It is not a lawyer referral service or prepaid legal services plan.This website is not a law firm.The sole basis for the inclusion of the participating lawyers or law firms is the payment of a fee for exclusive geographical advertising rights.A complete list of our joint advertising attorneys can be found here: ",
            tcpa9: "Sponsors",
            tcpa10: "You can request an attorney by name. Our company does not endorse or recommend any lawyer or law firm who participates in the network.It does not make any representation and has not made any judgment as to the qualifications, expertise or credentials of any participating lawyer.The information contained herein is not legal advice.Any information you submit to this website may not be protected by attorney- client privilege.All photos are of models and do not depict clients.All case evaluations are performed by participating attorneys.This website is for informational purposes only.By filling out the free consultation form, you are NOT forming an attorney- client relationship.You can only retain a lawyer by entering into a written retainer agreement with an attorney.Our services may not be available in all states.",
        },
        homePageYT: {
            firstTitle: "Claim maximum compensation for your",
            secondTitle: "damaged car, medical bills, and injuries.",
            firstSubtitle: "Inform us about your accident to schedule your",
            secondSubtitle: "FREE CONSULTATION",
            thirdSubtitle: "with our trusted personal injury lawyers.",
        },
        homePageFB: {
            firstTitle: "Receive",
            secondTitle: "Maximum Accident Injury Payout",
            thirdTitle: "with the Help of",
            fourthTitle: "Trusted Personal Injury Lawyers",
            firstSubtitle: "Take this quick assessment to get a",
            secondSubtitle: "FREE CASE CONSULTATION",
            thirdSubtitle: "and",
            fourthSubtitle: "know how much is owed to you",
        },
        homePageTT: {
            textBox: "Finish and submit the form to qualify for our free consultation offer"
        },
        form: {
            firstQuestion: {
                question: "How bad was your car accident?",
                option1: "I was injured",
                option2: "I was not injured at all",
            },
            secondQuestion: {
                question: "Are you currently represented by a lawyer for the accident?",
                option1: "No",
                option2: "Yes, I already have a lawyer/received compensation",
            },
            thirdQuestion: {
                question: "Are you at fault for the accident? Be honest",
                option1: "No, I am not at fault. The other driver owes damages.",
                option2: "Yes, it was my fault.",
                option3: "There was no one else there, I hit a tree/fallen object/weather problem."
            },
            fourthQuestion: {
                question: "Tell us about your accident",
                placeholder: "Please provide details about your accident...",
                minChars: "Min 40 characters",
                fiveHundred: "500 characters",
            },
            fifthQuestion: {
                question: "When did the accident happen?",
                option1: "Less than 3 months",
                option2: "3 to 6 months ago",
                option3: "6 to 12 months ago",
                option4: "1 to 2 years ago",
                option5: "More than 2 years",
            },
            sixthQuestion: {
                question: "First Name",
                title: "One of our friendly representatives will contact you shortly. Please tell us how we can reach you about your free consultation."
            },
            seventhQuestion: {
                question: "Last Name",
            },
            eighthQuestion: {
                question: "Your email",
                placeholder: "Please enter a valid email address"
            },
            ninthQuestion: {
                question: "What is your cell number? For us to call you about compensation please be ready to pick up",
                tcpa1: `By clicking "Submit and Get Free Consultation" you expressly consent to receive calls and text messages for marketing purposes from`,
                tcpa2: "Car Accident Counsel",
                tcpa3: "our affiliates, and marketing",
                tcpa4: "partners",
                tcpa5: "using automated technology including artificial pre-recorded voice. You agree that we may contact you at any time, including before 8am or after 9pm local time.Consent is not a condition of purchase.You agree to the use of electronic signatures, our",
                tcpa6: "Privacy Policy",
                tcpa7: ", and",
                tcpa8: "Terms of Use",
                submit: "Submit",
                format: "Format: XXX XXX XXXX (10 digits)",
                placeholder: "Introduce tu número de teléfono"
            },
            personalInfo: {
                title: "Contact Info"
            }
        }
    },
    sp: {
        homepage: {
            title: "Usted podría tener derecho a una indemnización máxima por accidente",
            text: "Consulta GRATUITA y sin compromiso ¡No pague nada!",
            text2: "Nuestros abogados expertos han sido calificados con 5 estrellas",
            tcpa1: `Al hacer clic en el botón "Siguiente" arriba, das tu consentimiento, reconoces y aceptas lo siguiente: Nuestros`,
            tcpa2: " Términos de Servicio",
            tcpa3: `y Política de Privacidad.Que estás otorgando un consentimiento expreso "por escrito" para que caraccidentcounsel.com o su`,
            tcpa4: "red de abogados y defensores pueda",
            tcpa5: "llamarte (marcación automática, mensajes de texto y mensajes pregrabados por conveniencia) a través de teléfono, dispositivo móvil (incluyendo SMS y MMS – pueden aplicarse cargos según tu proveedor, no por nosotros, la frecuencia de mensajes puede variar; envía AYUDA para ayuda; envía ALTO para cancelar), incluso si tu número de teléfono está actualmente en cualquier lista interna, corporativa, estatal o federal de No Llamar. Nos tomamos tu privacidad en serio y puedes recibir comunicaciones electrónicas, incluyendo correos electrónicos periódicos con noticias importantes, consejos financieros, herramientas y más. Puedes darte de baja en cualquier momento. Todas las interacciones en el sitio web y llamadas telefónicas son grabadas para fines de cumplimiento y control de calidad. El consentimiento no es un requisito para utilizar los servicios de caraccidentcounsel.com y no estás obligado a comprar nada.",
            tcpa6: "Este sitio no forma parte del sitio web de Facebook ni de Facebook Inc. Además, este sitio NO está respaldado por Facebook de ninguna manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.",
            tcpa7: "Este sitio no forma parte del sitio web de YouTube ni de Google, LLC. Además, este sitio NO está respaldado por Google de ninguna manera. YouTube es una marca registrada de Google, LLC.",
            tcpa8: "ANUNCIO PAGADO DE ABOGADO: Este sitio web es un anuncio grupal. No es un servicio de referencia de abogados ni un plan de servicios legales prepagados. Este sitio web no es un bufete de abogados. La única base para la inclusión de los abogados o bufetes participantes es el pago de una tarifa por derechos exclusivos de publicidad geográfica. Puedes encontrar una lista completa de nuestros abogados anunciantes conjuntos aquí:",
            tcpa9: "Patrocinadores",
            tcpa10: "Puedes solicitar un abogado por nombre. Nuestra empresa no respalda ni recomienda a ningún abogado o bufete que participe en la red. No hace ninguna declaración ni ha hecho ningún juicio sobre las calificaciones, experiencia o credenciales de ningún abogado participante. La información contenida aquí no constituye asesoramiento legal. Cualquier información que envíes a este sitio web puede no estar protegida por el privilegio abogado-cliente. Todas las fotos son de modelos y no representan a clientes. Todas las evaluaciones de casos son realizadas por abogados participantes. Este sitio web es solo con fines informativos. Al completar el formulario de consulta gratuita, NO estás formando una relación abogado-cliente. Solo puedes contratar a un abogado mediante un acuerdo de representación por escrito con un abogado. Nuestros servicios pueden no estar disponibles en todos los estados.",
        },
        homePageYT: {
            firstTitle: "Reclama la máxima compensación por tu",
            secondTitle: "Auto dañado, facturas médicas y lesiones.",
            firstSubtitle: "Infórmenos sobre su accidente para programar su cita",
            secondSubtitle: "CONSULTA GRATUITA",
            thirdSubtitle: "con nuestros abogados de confianza en lesiones personales.",
        },
        homePageFB: {
            firstTitle: "Recibir",
            secondTitle: "Pago máximo por lesiones por accidente",
            thirdTitle: "con la ayuda de",
            fourthTitle: "Abogados de lesiones personales de confianza",
            firstSubtitle: "Realice esta evaluación rápida para obtener una",
            secondSubtitle: "CONSULTA DE CASO GRATUITA",
            thirdSubtitle: "y",
            fourthSubtitle: "saber cuánto se te debe",
        },
        homePageTT: {
            textBox: "Complete y envíe el formulario para calificar para nuestra oferta de consulta gratuita"
        },
        form: {
            firstQuestion: {
                question: "¿Qué tan grave fue tu accidente de coche?",
                option1: "Me lesioné.",
                option2: "No me lesioné en absoluto.",
            },
            secondQuestion: {
                question: "¿Está actualmente representado por un abogado para el accidente?",
                option1: "No",
                option2: "Si",
            },
            thirdQuestion: {
                question: "¿Tiene la culpa del accidente? Sea honesto.",
                option1: "No, no tengo la culpa.",
                option2: "Sí, fue mi culpa.",
                option3: "No había nadie más allí. Golpeé a un animal, una zanja, un árbol o tuve un problema mecánico."
            },
            fourthQuestion: {
                question: "Cuéntenos sobre su accidente",
                placeholder: "Proporcione detalles sobre su accidente...",
                minChars: "Mínimo 40 caracteres",
                fiveHundred: "500 caracteres",
            },
            fifthQuestion: {
                question: "¿Cuando ocurrió el accidente?",
                option1: "Menos de 3 meses",
                option2: "Hace 3 a 6 meses",
                option3: "Hace 6 a 12 meses",
                option4: "Hace 1 o 2 años",
                option5: "Más de 2 años",
            },
            sixthQuestion: {
                question: "Nombre",
                title: "Uno de nuestros amables representantes se pondrá en contacto con usted en breve. Indíquenos cómo podemos contactarle para su consulta gratuita."
            },
            seventhQuestion: {
                question: "Apellido",
            },
            eighthQuestion: {
                question: "Tu correo electrónico",
                placeholder: "Por favor, introduce una dirección de correo electrónico válida"
            },
            ninthQuestion: {
                question: "¿Cuál es tu número de celular? Para que podamos llamarte y hablar sobre la compensación, por favor, prepárate para contestar.",
                tcpa1: `Al hacer clic en "Enviar y Obtener Consulta Gratuita", aceptas recibir llamadas y mensajes de texto con fines de marketing de`,
                tcpa2: "Car Accident Counsel",
                tcpa3: "nuestros afiliados y socios de marketing",
                tcpa4: "socios",
                tcpa5: "usando tecnología automatizada, incluyendo voces artificiales pregrabadas. Aceptas que podemos contactarte en cualquier momento, incluso antes de las 8 a.m. o después de las 9 p.m., hora local. El consentimiento no es una condición para la compra. Aceptas el uso de firmas electrónicas, nuestra",
                tcpa6: "Política de Privacidad",
                tcpa7: ", y",
                tcpa8: "Términos de Uso",
                submit: "Enviar",
                format: "Formato: XXX XXX XXXX (10 dígitos)",
                placeholder: ""
            },
            personalInfo: {
                title: "Información de contacto"
            }
        }
    }
};